<div class="text-3xl sm:font-rhetorik-sans mb-2">Oops!</div>
<div class="mb-2">
  <p>{{message}}</p>
</div>
<p>Please contact our support center at <a href="tel:{{triconSupportPhoneNumber}}"><u>{{triconSupportPhoneNumberDotFormat}}</u></a> for assistance.</p>
